import React from 'react';
import RecommendStoreDetailNavbar from '../RecommendStoreDetailNavbar';
import RecommendStoreDetailInfo from '../RecommendStoreDetailInfo';
import RecommendStoreDetailItemList from '../RecommendStoreDetailItemList';
import './RecommendStoreDetailWrap.scss';

const RecommendStoreDetailWrap = (props) => {
  const { recommendStoreDetail } = props;
  const { recommendStoreInfo, recommendStoreItemList } = recommendStoreDetail;

  return (
    <div className="recommend-store-detail-wrap">
      {/* 하단 네브바 */}
      <RecommendStoreDetailNavbar recommendStoreId={recommendStoreInfo.recommendStoreId} />

      {/* 추천 브랜드 정보 */}
      <RecommendStoreDetailInfo recommendStoreInfo={recommendStoreInfo} />

      {/* 추천 브랜드 아이템 리스트*/}
      <RecommendStoreDetailItemList recommendStoreItemList={recommendStoreItemList} />
    </div>
  );
};

export default RecommendStoreDetailWrap;
